var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c(
        "div",
        {
          staticClass: "sluzba-intro",
          staticStyle: {
            "background-image": "url('/theme/images/sluzby/img_eshop.jpg')",
            "background-size": "cover"
          }
        },
        [
          _c("div", { staticClass: "block-container heading-block" }, [
            _c("h1", [
              _vm._v("Tvoříme weby"),
              _c("span", { staticClass: "red" }, [_vm._v(".")])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "block-padding-lr" }, [
            _c("div", { staticClass: "line" })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "block-container" }, [
            _c("div", { staticClass: "intro-cols" }, [
              _c("div", { staticClass: "first-col" }, [
                _c("p", [
                  _vm._v(
                    "Multidisciplinary product designer specializing in systems, experience and interaction.Currently at Cash App "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "second-col" }, [
                _c("p", [
                  _vm._v(
                    "I'm a designer currently based in Seattle, where I'm part of the design team at Cash App. As a multidisciplinary designer, I specialize in interaction, visual, brand, motion, and more. I'm passionate about crafting seamless user experiences and thrive on challenges that demand creativity and innovation."
                  )
                ])
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "sluzby-reference-grid",
          attrs: { id: "reference-kare" }
        },
        [
          _c("div", { staticClass: "sluzby-reference-item--web-media" }, [
            _c("picture", [
              _c("source", {
                attrs: { srcset: "/theme/images/klienti/opice.jpg" }
              }),
              _vm._v(" "),
              _c("img", {
                staticClass: "sluzby-reference-item--web-media__image",
                attrs: {
                  src: "/theme/images/klienti/opice.jpg",
                  alt: "Kare web"
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "sluzby-reference-item sluzby-reference-item--web reference-item-3 reference-item-padding-lr reference-item-padding-tb"
            },
            [
              _c("div", { staticClass: "reference-item-3-text" }, [
                _c("span", { staticClass: "sluzby-reference-label" }, [
                  _vm._v("Kare")
                ]),
                _vm._v(" "),
                _c("h2", [_vm._v("Kare e-shop")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vitae explicabo suscipit nemo est! Possimus voluptatem id quas. Nulla libero illo quo aut architecto, vero eius, laborum natus minima, commodi quaerat."
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "reference-item-3-img-wrapper" }, [
                _c("img", {
                  attrs: { src: "/theme/images/klienti/kare.png", alt: "" }
                })
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "sluzby-reference-grid",
          attrs: { id: "reference-oooox" }
        },
        [
          _c("div", { staticClass: "sluzby-reference-item--web-media" }, [
            _c("picture", [
              _c("source", {
                attrs: { srcset: "/theme/images/sluzby/web/oooox.webp" }
              }),
              _vm._v(" "),
              _c("img", {
                staticClass: "sluzby-reference-item--web-media__image",
                attrs: {
                  src: "/theme/images/sluzby/web/oooox.jpg",
                  alt: "OOOOX web"
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "sluzby-reference-item--web-media__yt-video" },
              [
                _c("iframe", {
                  attrs: {
                    width: "1345",
                    height: "825",
                    "data-src":
                      "https://www.youtube.com/embed/b6wckpW7o1I?controls=0&modestbranding=1&rel=0&mute=1&autoplay=1&loop=1&playlist=b6wckpW7o1I",
                    autoplay: "",
                    muted: "",
                    allowfullscreen: ""
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass:
              "sluzby-reference-item sluzby-reference-item--web reference-item-3 reference-item-padding-lr reference-item-padding-tb"
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "sluzby-reference-grid",
          attrs: { id: "reference-sonet" }
        },
        [
          _c("div", { staticClass: "sluzby-reference-item--web-media" }, [
            _c("picture", [
              _c("source", {
                attrs: { srcset: "/theme/images/sluzby/web/sonet.webp" }
              }),
              _vm._v(" "),
              _c("img", {
                staticClass: "sluzby-reference-item--web-media__image",
                attrs: {
                  src: "/theme/images/sluzby/web/sonet.jpg",
                  alt: "Sonet web"
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "sluzby-reference-item sluzby-reference-item--web reference-item-3 reference-item-padding-lr reference-item-padding-tb"
            },
            [
              _c("div", {
                staticClass:
                  "sluzby-reference-item--web__content sluzby-reference-item--web__content--l"
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "sluzby-reference-item--web__content sluzby-reference-item--web__content--r"
                },
                [
                  _c("img", {
                    staticClass: "sluzby-reference-item--web__logo",
                    attrs: {
                      src: "/theme/images/sluzby/web/logo_sonet.svg",
                      alt: "Sonet logo"
                    }
                  }),
                  _vm._v(" "),
                  _c("h2", [
                    _vm._v(
                      "Přední česká firma komplexní služby v oblasti platebních technologií."
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "Klientky přicházející do MEDICOM Clinic musí získat ten nejlepší první dojem. Tak musí působit i brožury a tiskové materiály, které dostanou."
                    )
                  ])
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "sluzby-reference-grid",
          attrs: { id: "reference-cofee" }
        },
        [
          _c("div", { staticClass: "sluzby-reference-item--web-media" }, [
            _c("picture", [
              _c("source", {
                attrs: { srcset: "/theme/images/sluzby/web/cofee.webp" }
              }),
              _vm._v(" "),
              _c("img", {
                staticClass: "sluzby-reference-item--web-media__image",
                attrs: {
                  src: "/theme/images/sluzby/web/cofee.png",
                  alt: "Cofee web"
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "sluzby-reference-item sluzby-reference-item--web reference-item-3 reference-item-padding-lr reference-item-padding-tb"
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "sluzby-reference-item--web__content sluzby-reference-item--web__content--l"
                },
                [
                  _c("h2", [_vm._v("Web pro")]),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "sluzby-reference-item--web__logo",
                    attrs: {
                      src: "/theme/images/sluzby/web/logo_cofee.svg",
                      alt: "Cofee logo"
                    }
                  }),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "Klientky přicházející do MEDICOM Clinic musí získat ten nejlepší první dojem. Tak musí působit i brožury a tiskové materiály, které dostanou."
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", {
                staticClass:
                  "sluzby-reference-item--web__content sluzby-reference-item--web__content--r"
              })
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "sluzby-reference-grid",
          attrs: { id: "reference-pzk" }
        },
        [
          _c("div", { staticClass: "sluzby-reference-item--web-media" }, [
            _c("picture", [
              _c("source", {
                attrs: { srcset: "/theme/images/sluzby/web/pzk.webp" }
              }),
              _vm._v(" "),
              _c("img", {
                staticClass: "sluzby-reference-item--web-media__image",
                attrs: {
                  src: "/theme/images/sluzby/web/pzk.png",
                  alt: "PZK web"
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "sluzby-reference-item sluzby-reference-item--web reference-item-3 reference-item-padding-lr reference-item-padding-tb"
            },
            [
              _c("div", {
                staticClass:
                  "sluzby-reference-item--web__content sluzby-reference-item--web__content--l"
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "sluzby-reference-item--web__content sluzby-reference-item--web__content--r"
                },
                [
                  _c("img", {
                    staticClass: "sluzby-reference-item--web__logo",
                    attrs: {
                      src: "/theme/images/sluzby/web/logo_pzk.svg",
                      alt: "PZK logo"
                    }
                  }),
                  _vm._v(" "),
                  _c("h2", [
                    _vm._v(
                      "Přední česká firma komplexní služby v oblasti platebních technologií."
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "Klientky přicházející do MEDICOM Clinic musí získat ten nejlepší první dojem. Tak musí působit i brožury a tiskové materiály, které dostanou."
                    )
                  ])
                ]
              )
            ]
          )
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }